export const KONAMI_SEQUENCE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
] as const

export type KonamiKey = (typeof KONAMI_SEQUENCE)[number]

export function normalizeKonamiKey(key: string): KonamiKey | null {
  if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight') {
    return key
  }
  const lower = key.toLowerCase()
  if (lower === 'b' || lower === 'a') return lower as KonamiKey
  return null
}

export function advanceKonamiBuffer(buffer: KonamiKey[], pressed: string): KonamiKey[] {
  const normalized = normalizeKonamiKey(pressed)
  if (normalized === null) return buffer.length > 0 ? [] : buffer
  const nextIndex = buffer.length
  if (normalized !== KONAMI_SEQUENCE[nextIndex]) {
    return normalized === KONAMI_SEQUENCE[0] ? [normalized] : []
  }
  return [...buffer, normalized]
}

export function isKonamiComplete(buffer: KonamiKey[]): boolean {
  return buffer.length === KONAMI_SEQUENCE.length
}
